/**
 * Created by carlhaynes on 9/25/17.
 */
import React, { Component } from 'react';
import { Grid, Row, PageHeader } from 'react-bootstrap';
import {withRouter} from 'react-router-dom'
import Footer from "../Components/Footer";

class ComingSoon extends Component {

  render() {

    return (
          <Grid>
              <Row>
                  <PageHeader>Zoetrove</PageHeader>
              </Row>
              <Row>
                  ...we're working on it
              </Row>
          <Footer/>
          </Grid>
    );
  }
}

export default withRouter(ComingSoon);



// WEBPACK FOOTER //
// ./src/pages/ComingSoon.jsx